var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSyncclock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.00033 17.3332C4.39783 17.3332 0.666992 13.6023 0.666992 8.99984C0.666992 4.39734 4.39783 0.666504 9.00033 0.666504C13.6028 0.666504 17.3337 4.39734 17.3337 8.99984C17.3337 13.6023 13.6028 17.3332 9.00033 17.3332ZM9.00033 15.6665C10.7684 15.6665 12.4641 14.9641 13.7144 13.7139C14.9646 12.4636 15.667 10.7679 15.667 8.99984C15.667 7.23173 14.9646 5.53603 13.7144 4.28579C12.4641 3.03555 10.7684 2.33317 9.00033 2.33317C7.23222 2.33317 5.53652 3.03555 4.28628 4.28579C3.03604 5.53603 2.33366 7.23173 2.33366 8.99984C2.33366 10.7679 3.03604 12.4636 4.28628 13.7139C5.53652 14.9641 7.23222 15.6665 9.00033 15.6665ZM9.83366 8.99984H13.167V10.6665H8.16699V4.83317H9.83366V8.99984Z",
    fill: "#898989"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSyncclock);
export default __webpack_public_path__ + "static/media/syncclock.908b5082f8ac05d5f314a93ec0849ed8.svg";
export { ForwardRef as ReactComponent };